import { render, staticRenderFns } from "./CancelRemark.vue?vue&type=template&id=1ad52a91&scoped=true"
import script from "./CancelRemark.vue?vue&type=script&lang=js"
export * from "./CancelRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad52a91",
  null
  
)

export default component.exports